import { render, staticRenderFns } from "./TransferCoaSubhead.vue?vue&type=template&id=1b780447"
import script from "./TransferCoaSubhead.vue?vue&type=script&lang=js"
export * from "./TransferCoaSubhead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports